export const ROLE_ADMIN = 'admin'
export const ROLE_BUYER = 'buyer'
export const ROLE_PRIMARY_USER = 'primary-user'
export const ROLE_SUPPLIER = 'supplier'
